import axios from 'axios/index'

import config from '../../../config'
import action, { actionFailed } from '../../../util/action'
import createAsyncConst from '../../../util/createAsyncConst'

export const REMOVE_LAUNDRY = createAsyncConst('REMOVE_LAUNDRY')
export const SUBMIT_LAUNDRY = createAsyncConst('SUBMIT_LAUNDRY')
export const FETCH_LAUNDRY = createAsyncConst('FETCH_LAUNDRY')
export const FETCH_LAUNDRY_INIT = createAsyncConst('FETCH_LAUNDRY_INIT')
export const FETCH_LAUNDRY_FILTERS = createAsyncConst('FETCH_LAUNDRY_FILTERS')
export const EDIT_LAUNDRY = createAsyncConst('EDIT_LAUNDRY')
export const NEW_DETACHED = createAsyncConst('NEW_DETACHED')
export const GET_DETACHEDS = createAsyncConst('GET_DETACHEDS')
export const REMOVE_DETACHEDS = createAsyncConst('REMOVE_DETACHEDS')

export const FETCH_APPOINTMENTS = createAsyncConst('FETCH_APPOINTMENTS')

// new consts
export const SYNC_ATTENDANTS = createAsyncConst('SYNC_ATTENDANTS')

export function fetchAppointments(filters = {}, rows = 10, page = 1) {
  return dispatch => {
    dispatch(action(FETCH_APPOINTMENTS.ACTION))
    return axios
      .get(`${config.API_URL}/laundry-appointments`, {
        params: {
          ...filters,
          page,
          rows,
        },
      })
      .then(resp => {
        dispatch(action(FETCH_APPOINTMENTS.SUCCESS, resp))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_APPOINTMENTS, e)))
  }
}

export function removeAppointment(id) {
  return dispatch => {
    dispatch(action(REMOVE_DETACHEDS.ACTION, { id }))
    return axios
      .delete(`${config.API_URL}/laundry/remove-appointment/${id}`)
      .then(resp => {
        return resp.data
      })
      .then(data => dispatch(action(REMOVE_DETACHEDS.SUCCESS, data)))
      .catch(e => dispatch(actionFailed(REMOVE_DETACHEDS, e)))
  }
}

export function newAppointment(data, id) {
  return dispatch => {
    dispatch(action(NEW_DETACHED.ACTION, { id }))
    return axios
      .post(`${config.API_URL}/laundry/new-appointment/${id}`, data)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(NEW_DETACHED.SUCCESS, data))
        return data
      })
      .catch(e => {
        dispatch(actionFailed(NEW_DETACHED, e))
        return e
      })
  }
}

function submit(values, method, id = null) {
  return dispatch => {
    dispatch(action(SUBMIT_LAUNDRY.ACTION))
    return axios[method](
      `${config.API_URL}/laundry${id ? `/${id}` : ''}`,
      values
    )
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_LAUNDRY.SUCCESS, data))
        dispatch(fetchLaundries())
        return data
      })
      .catch(e => dispatch(actionFailed(SUBMIT_LAUNDRY, e)))
  }
}
